import React from "react";
import { NavigateOptions, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/sharp-regular-svg-icons";

import styles from "./header.module.scss";

type NavigateBackButtonProps = {
  route?: string | (() => void);
  navigateOptions?: NavigateOptions;
};

const NavigateBackButton = ({
  route,
  navigateOptions,
}: NavigateBackButtonProps) => {
  const navigate = useNavigate();

  if (!route) {
    return <div className={styles.backButtonFiller} />;
  }

  const handleBack = () => {
    if (typeof route === "function") {
      route();
    } else {
      navigate(route, navigateOptions);
    }
  };

  return (
    <div className={styles.backButtonContainerOuter}>
      <div className={styles.backButtonContainerInner}>
        <button onClick={handleBack} type="button" aria-label="go back">
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>
      </div>
    </div>
  );
};

export default NavigateBackButton;
